import { useCallback, useEffect, useState } from 'react';

import type { EgsDraft, EgsDraftInput } from './types';

export function useEgsDrafts(offerId: string | undefined) {
  const [drafts, setDrafts] = useState<Array<EgsDraft>>([]);

  useEffect(() => {
    setDrafts([]);
  }, [offerId]);

  const addRecords = useCallback((records: Array<EgsDraftInput>) => {
    const now = new Date().toISOString();
    const newDrafts: Array<EgsDraft> = records.map((record) => ({
      ...record,
      id: crypto.randomUUID(),
      createdAt: now,
      updatedAt: now,
    }));
    setDrafts((prevDrafts) => [...prevDrafts, ...newDrafts]);
    return newDrafts;
  }, []);

  const removeDraft = useCallback((id: string) => {
    setDrafts((prevDrafts) => prevDrafts.filter((draft) => draft.id !== id));
  }, []);

  return { drafts, addRecords, removeDraft };
}
